<template>
  <div class="page-wrapper ticket-detail-wrapper" ref="ticket">
      <div class="movie-box page-relative ticket-detail-swiper-wrapper">
          <!-- 返回 -->
          <div class="movie-box page-absolute back-wrapper">
             <MovieGoBack :style="backstyle"></MovieGoBack>
          </div>
          <!-- swiper -->
          <Swiper :swiperStyle="swiperStyle" :imgOption="imgOption" :data="swiperData"></Swiper>
      </div>
      <!-- 开放时间 -->
      <div class="movie-box padding30 page-background-color-white ticket-detail-info-wrapper">
          <h1 class="title-font-size">{{scenic.title}}</h1>
          <p class="font-color-red margin-top">{{scenic.open_time_desc}}</p>
          <div class="margin-top movie-box padding20 page-relative ticket-detail-address-wrapper" @click="isShowMap">
              <span>
                  <i class="iconfont icon-ditu icon-color"></i>
                  {{scenic.address}}
              </span>
              <span class="page-absolute icon-color address-right">›</span>
          </div>
      </div>
      <!-- nav -->
      <!-- 顶部定位的nav -->
      <ul v-if="fixed_nav" class="movie-wrapper acea-row row-middle row-around page-background-color-white ticket-nav-wrapper fixed_nav z-index200">
          <li class="ticket-nav" :class="{'page-bg-color-checked': currentNav === ind}" v-for="(item, ind) in navInfo" :key="ind" @click="changeNav(ind)">{{item.title}}</li>
      </ul>
      <!-- 未定位的nav -->
      <div class="movie-box ticket-nav-wrapper" ref="ticketNav">
        <ul v-if="!fixed_nav" class="movie-wrapper acea-row row-middle row-around page-background-color-white">
            <li class="ticket-nav" :class="{'page-bg-color-checked': currentNav === ind}" v-for="(item, ind) in navInfo" :key="ind" @click="changeNav(ind)">{{item.title}}</li>
        </ul>
      </div>
      <!-- 门票模块 -->
      <div class="margin-top movie-wrapper page-background-color-white ticket-border-bottom nav-title-wrapper" ref="ticket_goy">
          <i class="iconfont icon-youhuiquan icon-color"></i>
          {{navInfo[0].title}}
      </div>
      <div class="movie-box page-background-color-white">
          <div v-if="ticketList.length === 0 && universalStudios.length === 0" class="padding20 page-text-center">暂无</div>
          <div v-if="universalStudios.length == 0 && crtip_id != 2045497">
            <div class="movie-box padding30 ticket-border-bottom acea-row row-between-wrapper ticket-reserve" v-for="(item, ind) in ticketList" :key="ind" @click="yuDing(item)">
                <div class="page-flex-1">
                    {{item.ticketType}}
                </div>
                <div class="page-text-center ticket-reserve-right-wrapper">
                    <span class="font-color-red">{{item.price}}<span class="qiStyle">起</span></span>
                    <div class="page-text-center movie-gradient ticket-button">预定</div>
                </div>
            </div>
          </div>
          <div v-else>
              <div class="movie-box" v-for="(item, ind) in universalStudios" :key="ind" >
                  <div class="movie-box acea-row row-between-wrapper page-padding-right7 page-relative">
                      <div class="kazhu">{{item.title}}</div>
                      <div class="page-absolute jianTou" v-if="!item.isShow" @click="changeZ(ind, true)">﹀</div>
                      <div class="page-absolute jianTou" v-if="item.isShow" @click="changeZ(ind, false)">︿</div>
                  </div>
                  <div v-if="item.isShow">
                    <div class="movie-box padding30 ticket-border-bottom acea-row row-between-wrapper ticket-reserve" v-for="(val, index) in item.list" :key="index" @click="yuDing(val)">
                        <div class="page-flex-1">
                            {{val.ticketType}}
                        </div>
                        <div class="page-text-center ticket-reserve-right-wrapper">
                            <span class="font-color-red">{{val.price}}<span class="qiStyle">起</span></span>
                            <div class="page-text-center movie-gradient ticket-button">预定</div>
                        </div>
                    </div>
                </div>
              </div>
          </div>
      </div>
      <!-- 景点介绍 -->
      <div class="margin-top movie-wrapper page-background-color-white ticket-border-bottom nav-title-wrapper" ref="scenic">
          <i class="iconfont icon-shitixing icon-color"></i>
          {{navInfo[1].title}}
      </div>
      <div class="movie-box padding30 page-background-color-white introduction-wrapper" v-html="navInfo[1].description"></div>

      <!-- 温馨提示 -->
      <div class="margin-top movie-wrapper page-background-color-white ticket-border-bottom nav-title-wrapper" ref="tip">
          <i class="iconfont icon-shuoming icon-color"></i>
          {{navInfo[2].title}}
      </div>
      <div class="movie-box padding30 page-background-color-white">
        <dl v-for="(item, ind) in navInfo[2].description_list" :key="ind" class="page-margin-bottom3">
            <dt class="page-margin-bottom1 title-title">▶ {{item.name}}</dt>
            <dd v-for="(val, key) in item.list" :key="key" class="page-margin-bottom2" v-html="val.DescDetail"></dd>
        </dl>
      </div>

      <!-- 交通信息 -->
      <div class="margin-top movie-wrapper page-background-color-white ticket-border-bottom nav-title-wrapper" ref="traffic">
          <i class="iconfont icon-color">➤</i>
          {{navInfo[3].title}}
      </div>
      <div class="movie-box padding30 page-background-color-white">
          <dl v-for="(item, ind) in navInfo[3].description_list" :key="ind">
              <dd v-for="(val, key) in item.list" :key="key"><div v-html="val.DescDetail"></div></dd>
          </dl>
      </div>

  </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import Swiper from '@components/Swiper.vue';
import debounce from "lodash.debounce";
import { getTicketDetailData } from "@api/ticket.js";
import { roundFun } from "@utils/movie.js";
import { getCouponsUser } from "@api/user";

export default {
    name: "TicketDetail",
    components:{
        MovieGoBack,
        Swiper
    },
    data: function() {
        return {
            backstyle: {
                background: "transparent"
            },
            swiperStyle: {},
            imgOption: {},
            swiperData: [
            // {
            //     pic: "https://dimg01.c-ctrip.com/images/0106c120008jz4y6pAB51_R_1600_10000.jpg"
            // }
            ],
            navInfo: [
                {title:"门票", id: 0}, 
                {title:"景点介绍", id: 1, description: ""},
                {title:"温馨提示", id: 2, description_list: []},
                {title:"交通信息", id: 3, description_list: []}
            ],
            currentNav: 0,
            ticketList: [
                // {
                //     price: 280,
                //     id: 0,
                //     ticketType: "朝阳剧场杂技中华绝技秀门票成人票-280元档"
                // }
            ],
            fixed_nav: false,
            id: this.$route.params.id || "",
            scenic: {
                title: "",
                open_time_desc: "",
                address: "",
                latitude: "",
                longitude: ""
            },
            crtip_id: null, //crtip_id
            universalStudios: [], //环球影城
            //
            cannot_purchase_goods: [ // 不能购买商品、门票，只能用于购买电影的点券
                { min: 80026683, max: 80027063 },
                // 测试↓
                { min: 80027183, max: 80027184 }
            ],
            isCannot_p: false
            //
        }
    },
    // watch: {
    //     $route (to, from) {
    //         console.log(to.name,"详情-监听-路由")
    //     },
    //     '$route.params.id': function (newVal, old) {
    //         console.log("监听到", newVal, this.id)
    //         if (newVal && newVal !== this.id) {
    //             this.id = newVal;
    //             this.getData();
    //         }
    //     }
    // },
    activated: function () {
        // console.log("能监听到的",this.$route)
        if (this.id !== this.$route.params.id) {
            this.id = this.$route.params.id;
            this.navInfo[2].description_list = [];
            this.navInfo[3].description_list = [];
            this.ticketList = [];
            this.universalStudios = [];
            this.fixed_nav = false;
            const dom = this.$refs.ticket;
            dom.scrollBy({top: 0, left: 0});
            this.$nextTick(()=>{
                this.getData();
                this.isQujian();
            });
        } else {
            const dom = this.$refs.ticket;
            dom.scrollBy({top: this.scrollT, left: 0})
        }
    },
    mounted: function() {
        const dom = this.$refs.ticket;
        // console.log("缓存-mounted走不走")
        //获取数据
        this.getData();
        this.isQujian();
        dom.addEventListener("scroll", debounce(this.onScroll, 100), false);
    },
    methods: {
        changeZ(index, bool) {
            this.universalStudios[index].isShow = bool;
        },
        yuDing: function (item) {
            if (this.isCannot_p) {
                this.cannotPFn();
                return;
            }
            this.$router.push({
                path:`/ticketPlaceOrder/${item.id}/${item.crtip_id}`
            });
        },
        isQujian: async function () {
            await getCouponsUser(0).then(res => {
                this.couponsList = res.data || [];
            });
            let card = this.couponsList;
            let isT = false;
            for(let t=0;t<card.length;t++) {
                let card_id = card[t].coupon_title;
                // console.log(card_id,"t");
                for(let i=0; i<this.cannot_purchase_goods.length;i++) {
                    // console.log(i,"i")
                    if (card_id >= this.cannot_purchase_goods[i].min && card_id <= this.cannot_purchase_goods[i].max) {
                        if (card_id != 80026760 && card_id != 80026695 && card_id != 80027047 && card_id != 80026958 && card_id != 80026957) {
                            this.isCannot_p = true;
                            isT = true;
                            // console.log("结束--")
                            break;
                        }
                    }
                }
                if (isT) {
                    break;
                }
            }
            if (this.isCannot_p) {
                // console.log("不能--使用--")
                this.cannotPFn();
            }
        },
        cannotPFn() {
            this.$dialog.error("此券仅限观影使用！");
        },
        isShowMap: function () {
            this.$router.push(
                {
                    path: "/ticketMap",
                    query: {
                        latitude: this.scenic.latitude,
                        longitude: this.scenic.longitude
                    }
                }
            );
        },
        getData: function () {
            let id = this.id || this.$route.params.id;
            this.$dialog.loading.open("正在加载中");
            getTicketDetailData(id).then((res)=>{
                this.$dialog.loading.close();

                this.crtip_id = res.data.crtip_id;
                //console.log(res,"res");
                let list = [];
                res.data.priceList && res.data.priceList.forEach((item, index)=>{
                    list.push({
                        price: roundFun(item.CtripPrice, 2),//价格
                        id: item.ID,
                        ticketType: item.Name,
                        crtip_id: res.data.crtip_id || null
                    });
                });
                this.ticketList = list; //门票列表
                
                //环球影城分组
                if (res.data.crtipList && res.data.crtipList.length !== 0 && res.data.crtip_id == 2045497) {
                    let _studio = res.data.crtipList || [];
                    let new_list = [];
                    _studio && _studio.forEach((resl)=>{
                        let _lis = [];
                        resl.list && resl.list.forEach((lis)=> {
                            _lis.push({
                                price: roundFun(lis.CtripPrice, 2),//价格
                                id: lis.ID,
                                ticketType: lis.Name,
                                crtip_id: res.data.crtip_id || null
                            })
                        })
                        new_list.push({
                            title: resl.name,
                            isShow: false,
                            list: _lis
                        });
                    });
                    new_list[0].isShow = true;
                    this.universalStudios = new_list;
                }
                



                let open_time = res.data.open_time_desc || "";
                this.scenic = { //景点信息
                    title: res.data.name,
                    open_time_desc: open_time,
                    address: res.data.address,
                    latitude: parseFloat(res.data.latitude || null),
                    longitude: parseFloat(res.data.longitude || null)
                };

                if (res.data.crtip_id == 2045497) { //环球影城
                    let _ti = open_time.split(' ');//'全年 '+ _ti[1] +_ti[_ti.length-1]+ ' 周六周日 09:00-20:00'
                    this.scenic.open_time_desc = "全年 周一-周五10:00-19:00 周六日09:00-20:00 说明：景区开放时间动态变化，实际请以出行当天景区官方小程序公示的营业时间为准" ;
                }

                this.swiperData = [{pic: res.data.image_url}]; //swiper数据
                this.navInfo[1].description = res.data.description; //景点介绍
                let navInfo_list = this.navInfo;
                res.data.info && res.data.info.forEach((val, key)=>{
                    navInfo_list.forEach((item, ind)=> {
                        if (item.id === 2 && (val.AddInfoTitleCode == "1" || val.AddInfoTitleCode == "4")) { // 温馨提示
                            
                            if (res.data.crtip_id == 2045497 && val.AddInfoSubTitleCode == "98") { //环球影城
                                val.ProductAddInfoDetailList[0].DescDetail = "开放时间：全年 周一-周五10:00-19:00 周六日09:00-20:00（说明：景区开放时间动态变化，实际请以出行当天景区官方小程序公示的营业时间为准）";
                            }
                            
                            item.description_list.push({
                                name: val.AddInfoSubTitleName,
                                list: val.ProductAddInfoDetailList
                            });
                        }
                        if (item.id === 3 && val.AddInfoTitleCode == "42" && val.AddInfoSubTitleCode == "18") {// 交通信息
                            item.description_list.push({
                                list: val.ProductAddInfoDetailList
                            })
                        }
                    })
                });

                this.navInfo = [...navInfo_list];

                this.$nextTick(()=>{
                    this.navDistance();
                });

            }).catch((err)=>{
                console.log(err);
                this.$dialog.loading.close();
            });
        },
        navDistance: function () {

            let ticket_goy = this.$refs.ticket_goy.offsetTop;//门票
            let scenic = this.$refs.scenic.offsetTop;//景点介绍
            let tip = this.$refs.tip.offsetTop;//温馨提示
            let traffic = this.$refs.traffic.offsetTop;//交通
            let distance_arr = [ticket_goy, scenic, tip, traffic];
            
            this.navInfo.forEach((item,ind)=>{
                item.distance = distance_arr[ind];
            });
        },
        onScroll: function(e) {
            let scrollT = e.target.scrollTop;
            this.scrollT = scrollT;
            let nav = this.$refs.ticketNav.offsetTop;//导航
            
            // console.log(e.target.scrollTop,"=e",nav,"=nav");
            //判断吸顶
            if ( scrollT > nav+50) {
                this.fixed_nav = true;
            } else if (scrollT <= nav-10) {
                this.fixed_nav = false;
            }
            //判断当前滚动条所在区间
            this.navInfo.forEach((item,ind)=>{
                if (scrollT >= item.distance-50) {
                    this.currentNav = ind;
                }
            })
        },
        changeNav: function(id) {
            const dom = this.$refs.ticket;
            this.navInfo.forEach((item, ind)=> {
                if (ind == id) {
                    dom.scrollTo(0, item.distance);
                    if (this.scrollT >= item.distance) {
                        this.currentNav = id;
                    }
                }
            })
            
        }
    },
    beforeDestroy: function() {
        // const dom = this.$refs.ticket;//需要缓存滚动条位置不删除
        // dom.removeEventListener("scroll", this.onScroll, false);
    }
}
</script>

<style scoped>
.qiStyle {
    font-size: .2rem;
    padding-left: .03rem;
}
.title-title {
    font-size: .3rem;
    font-weight: 550;
}
.introduction-wrapper > .inset-p {
    margin-bottom: .2rem;
}
.ticket-detail-swiper-wrapper {
    height: 4.2rem;
}
.back-wrapper {
    top: 0;
    left: 0;
    z-index: 5;
}

.ticket-detail-info-wrapper {
    min-height: 2rem;
    margin-bottom: .2rem;
}
.title-font-size {
    font-size: .34rem;
    line-height: .4rem;
}
.margin-top {
    margin-top: .2rem;
}
.ticket-detail-address-wrapper {
    background: #ffc0cb4a;
    padding-right: .3rem;
    border-radius: .2rem;
}
.address-right {
    top: 50%;
    transform: translate(0,-52%);
    right: .14rem;
    font-size: .5rem;
    font-weight: 400;
}
.ticket-nav-wrapper {
    height: 1.1rem;
}
.ticket-nav {
    height: 100%;
    line-height: 1rem;
}
.nav-title-wrapper {
    line-height: 1rem;
}
.ticket-border-bottom {
    border-bottom: .02rem solid #eee;
}
.ticket-reserve {
    min-height: 1rem;
}
.ticket-reserve-right-wrapper {
    width: 1.5rem;
    font-size: .3rem;
}
.ticket-button {
    width: 100%;
    height: .6rem;
    border-radius: .3rem;
    line-height: .6rem;
    color: #fff;
    margin-top: .1rem;
}
.fixed_nav {
    position: fixed;
    top: 0;
    left: 0;
}
.fixed_box-margin-top {
    margin-top: 1.2rem;
}
.kazhu {
    margin-top: .3rem;
    min-height: .7rem;
    line-height: .6rem;
    padding-left: .2rem;
    font-size: .34rem;
    font-weight: 600;
}
.jianTou {
    right: .3rem;
}
</style>